import Vue from 'vue'
var broadcast = new Vue()
export default broadcast